import axios from 'axios';
import { API_ENDPOINTS } from '../constants/apiConstant';

const BASE_URL = "https://techsolutionsservice.ustdev.com/";

export const saveUser = async (userData) => {
    const response = await axios.post(`${BASE_URL}signup/saveData`,userData);
    return response.data;
};

export const getUserById = async (Id) => {
    const response = await axios.get(`${BASE_URL}signup/supplierData/${Id}`,{headers:{
        Authorization:`Bearer ${sessionStorage.getItem("authToken")}`
      }});
    return response.data;
};

export const updateUser = async (emailId, userData) => {
    const response = await axios.put(`${BASE_URL}signup/update/${emailId}`, userData,{headers:{
        Authorization:`Bearer ${sessionStorage.getItem("authToken")}`
      }});
    return response.data;
};

export const signupApiService = {
    saveOrUpdateUser: async (userData, emailId) => {
        try {
            if (emailId) {
                return await updateUser(emailId, userData,{headers:{
                    Authorization:`Bearer ${sessionStorage.getItem("authToken")}`
                  }});
            } else {
                return await saveUser(userData,{headers:{
                    Authorization:`Bearer ${sessionStorage.getItem("authToken")}`
                  }});
            }
        } catch (error) {
            console.error('Error in user operation:', error);
            throw error;
        }
    }
};